
import { useSelector } from 'react-redux';
import MenuExpediente from './menuExpediente';
import MenuDmts from './menuImportacao';
import MenuDlifDesalfandegamento from './menuDlifDesalfandegamento';
import MenuDlifLicenciamento from './menuDlifLicenciamento';
import VerifyPermission from '../../../utils/verifyPermission';
import { makeStyles } from '@material-ui/core';
import MenuFarmacovigilancia from './menuFarmacovigilancia';
import MenuControleQualidade from './menuControleQualidade';
import MenuDmtsCertificadoProdutoControlado from './menuDmtsCertificadoProdutoControlado';
import { Alert, AlertTitle } from '@mui/material';
import MenuMedicamentos from './menuMedicamentos';
import ServicoExpedienteAreas from './servicoExpedienteAreas';
import ServicoReclamacoesAreas from './servicoReclamacoesAreas';


const useStyles = makeStyles((theme) => ({
  containerCardesService: {
    // minHeight: '50vh',
    padding: '1rem',
    display: 'flex',
    flexWrap: 'wrap',
    // justifyContent: 'center',
    alignItems: 'center',
    gap: '2rem',
  }
}))

export default function Menus() {
  const classes = useStyles();
  const user = useSelector(state => state.account.user);

  const Header = ({ title, marginBottom }) => {
    return (
      <div style={{ margin: 40, marginBottom: marginBottom ?? '' }}>
        <h1 style={{ margin: 20, fontSize: 23 }}>
          {title}
        </h1>
        <hr style={{ border: '1px solid #85287e' }} />
      </div>
    )
  }

  // "DGA SE",
  // "DGS SA",
  // "DCITMS",
  // "DADG",
  // "DASG",
  // "DCQMTS",
  // "DFTEC",
  // "DLIF",
  // "DMTS",

  return (
    <>
      {user?.permissions?.length === 0 &&
        <Alert severity="warning" style={{ margin: 20 }}>
          <AlertTitle>{'Usuario(a) está sem privilégios no sistema.!'}</AlertTitle> 
        </Alert>
      }

      <VerifyPermission permissions={user?.permissions} permission={'secçãoLicenciamento'} verificacaoSimples={true}>
        <section>
          <Header title={'LICENCIAMENTO'} />
          <MenuDlifLicenciamento styles={classes.containerCardesService} >
            <ServicoReclamacoesAreas permissao='reclamacoesLicenciamento' nomeArea='DLIF' nomeService='Reclamações' />
            <ServicoExpedienteAreas permissao='expedienteLicenciamento' nomeArea='DLIF' nomeService='Expediente' />
          </MenuDlifLicenciamento>
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoCertificadoProdutoControlo'} verificacaoSimples={true}>
        <Header title={'CERTIFICADOS PARA PRODUTO CONTROLADO'} />
        <MenuDmtsCertificadoProdutoControlado styles={classes.containerCardesService} >
          <ServicoReclamacoesAreas permissao='reclamacoesProdutoControlado' nomeArea='DCQMTS' nomeService='Reclamações' />
          <ServicoExpedienteAreas permissao='expedienteProdutoControlado' nomeArea='DCQMTS' nomeService='Expediente' />
        </MenuDmtsCertificadoProdutoControlado>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoImportação'} verificacaoSimples={true}>
        <Header title={'IMPORTAÇÃO'} />
        <MenuDmts styles={classes.containerCardesService} >
          <ServicoReclamacoesAreas permissao='reclamacoesImportacao' nomeArea='DLIF' nomeService='Reclamações' />
          <ServicoExpedienteAreas permissao='expedienteImportacao' nomeArea='DLIF' nomeService='Expediente' />
        </MenuDmts>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoDesalfandegamento'} verificacaoSimples={true}>
        <section>
          <Header title={'DESALFANDEGAMENTO'} />
          <MenuDlifDesalfandegamento styles={classes.containerCardesService} >
            <ServicoReclamacoesAreas permissao='reclamacoesDesalfandegamento' nomeArea='DLIF' nomeService='Reclamações' />
            <ServicoExpedienteAreas permissao='expedienteDesalfandegamento' nomeArea='DLIF' nomeService='Expediente' />
          </MenuDlifDesalfandegamento>
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoExpediente'} verificacaoSimples={true}>
        <section>
          <Header title={'EXPEDIENTE'} marginBottom={20} />
          <MenuExpediente styles={classes.containerCardesService} >
            <ServicoReclamacoesAreas permissao='reclamacoesExpediente' nomeArea='DADG' nomeService='Reclamações' />
          </MenuExpediente>
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoControleQualidade'} verificacaoSimples={true}>
        <section>
          <Header title={'CONTROLO DE QUALIDADE'} />
          <MenuControleQualidade styles={classes.containerCardesService} >
            <ServicoReclamacoesAreas permissao='reclamacoesControloQualidade' nomeArea='DCQMTS' nomeService='Reclamações' />
            <ServicoExpedienteAreas permissao='expedienteControloQualidade' nomeArea='DCQMTS' nomeService='Expediente' />
          </MenuControleQualidade>
        </section>
      </VerifyPermission>

      {/* secçãoFarmacovigilancia */}
      <VerifyPermission permissions={user?.permissions} permission={'secçãoFarmacovigilância'} verificacaoSimples={true}>
        <section>
          <Header title={'FARMACOVIGILÂNCIA'} />
          <MenuFarmacovigilancia styles={classes.containerCardesService} >
            <ServicoReclamacoesAreas permissao='reclamacoesFarmacovigilancia' nomeArea='DCQMTS' nomeService='Reclamações' />
            <ServicoExpedienteAreas permissao='expedienteFarmacovigilancia' nomeArea='DCQMTS' nomeService='Expediente' />
          </MenuFarmacovigilancia>
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoMedicamentos'} verificacaoSimples={true}>
        <section>
          {/* <Header title={'MEDICAMENTOS'} /> */}
          <Header title={'REGISTO DE MEDICAMENTOS'} />
          <MenuMedicamentos styles={classes.containerCardesService} >
            <ServicoReclamacoesAreas permissao='reclamacoesMedicamentos' nomeArea='DCQMTS' nomeService='Reclamações' />
            <ServicoExpedienteAreas permissao='expedienteMedicamentos' nomeArea='DCQMTS' nomeService='Expediente' />
          </MenuMedicamentos>
        </section>
      </VerifyPermission>
    </>
  )
}





